import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const adminLoginApi = async (data) =>
    Promise.resolve(axios.post(endpoints.adminLogin, data));

export const getAdminPanelDataApi = async () =>
    Promise.resolve(axios.get(endpoints.adminPanelData));
